<template>
    <div class="articles">
        <ArticlesListComponent/>
        <!-- <SiteMapComponent/> -->
        <!-- <h1>リスト一覧</h1> -->
        <!-- <div v-for="article in articles" :key="article.id"> -->
          <!-- <p class="article_title"><router-link :to="{name:'article', params:{ id: article.title}}">{{article.title}}</router-link></p> -->
          <!-- リンク用 -->
          <!-- <a :href="'https://dream.microcms.io/apis/article/' + article.id"><li>{{article.title}}</li></a>
          <p>https://dream.ameneko.com/article/{{article.title}}</p> -->
        <!-- </div> -->
        <!-- <div class="next-page">
          <p v-if="this.$route.query.id && articles.length == 100"><router-link  :to="{name: 'articles', query:{id:query_num_up}}">次へ</router-link></p>
          <p v-if="this.$route.query.id && articles.length == 100"><router-link  :to="{name: 'articles', query:{id:query_num_down}}">戻る</router-link></p>
          <p v-if="!this.$route.query.id"><router-link  :to="{name: 'articles', query:{id:100}}">次へ</router-link></p>
        </div> -->
        <!-- サイトマップ よう -->
        <!-- <div>
            <div v-for="article in articles" :key="article.id">
              &lt;url&gt;
              <br>&lt;loc&gt;
                https://dream.ameneko.com/article/{{article.title}}
                &lt;/loc&gt;   
              <br>&lt;/url&gt;
          </div>
        </div>  -->
        <!-- 一覧リスト用 -->
        <!-- <div>
            <div v-for="article in articles" :key="article.id">
              &lt;li&gt;
                &lt;a href="https://dream.ameneko.com/article/{{article.title}}"&gt;
                {{article.title}}
                &lt;/a&gt;
              &lt;/li&gt;
          </div>
        </div>  -->
    </div>
</template>
<script>
// import axios from "axios";
import ArticlesListComponent from '@/components/ArticlesListComponent.vue'
import SiteMapComponent from '@/components/SiteMapComponent.vue'
export default {
  components: {
    ArticlesListComponent,
    SiteMapComponent
  },
//   data(){
//     return{
//       articles: [],
//     }
//   },
//   computed:{
//     query_num_up() {
//       return Number(this.$route.query.id) + 100
//     },
//     query_num_down() {
//       return Number(this.$route.query.id) - 100
//     },  
//   },
//   watch: {
//     '$route' (to) {
//       this.$router.go(to.params.id)
//     },
//   },
//   mounted() {
//     this.fetchNotice();
//     const title = "リスト一覧｜夢占い辞典ゆめみん"
//     const description = "夢占い辞典ゆめみんのリスト一覧です"
//     const twitter_image = 'https://dream.ameneko.com/ogpImage.jpeg'
//     const og_image = 'https://dream.ameneko.com/topImage.jpeg'
//     document.title = title
//     document.querySelector("meta[property='og:image']").setAttribute('content', og_image)
//     document.querySelector("meta[name='twitter:image']").setAttribute('content', twitter_image)
//     document.querySelector("meta[property='og:title']").setAttribute('content', title)
//     document.querySelector("meta[name='description']").setAttribute('content', description)
//     document.querySelector("meta[property='og:description']").setAttribute('content', description)
// },
//   methods: {
//     fetchNotice() {
//       if(!this.$route.query.id){
//         axios.get("https://dream.microcms.io/api/v1/article?limit=100", {
//           headers: { "X-API-KEY": process.env.VUE_APP_MICRO_CMS }
//         }).then(res => {
//           this.articles = res.data.contents;
//         }).catch(err => {
//           console.log(err);
//         });
//       }else{
//         axios.get("https://dream.microcms.io/api/v1/article?" + "offset=" + this.$route.query.id + "&limit=100", {
//           headers: { "X-API-KEY": process.env.VUE_APP_MICRO_CMS }
//         }).then(res => {
//           this.articles = res.data.contents;
//         }).catch(err => {
//           console.log(err);
//         });
//       }
//     },
//   },
};
</script>

<style scoped>

</style>